export const calendarMonth_February = "Nqa";
export default {calendarMonth_February};